//import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        token: null,
        user: null
    },
    reducers: {
        authLogin: (state, action) => {
            state.token = action.payload.token;
            state.user = action.payload.user;
			//axios.defaults.headers.common['Authorization'] = 'Bearer ' + result.data.token;
			//document.body.setAttribute('scheme', 'admin');
        },
        authLogout: (state) => {
            state.token = null;
            state.user = null;
            //delete axios.defaults.headers.common['Authorization'];
            //document.body.removeAttribute('scheme');
        },
    }
});

export const { authLogin, authLogout } = authSlice.actions;
export default authSlice.reducer;
